import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-press", (props) => {
  return <ContentBlocks className="text-wrap" blocks={props.press?.contentBlocks} />
})
